import { render, staticRenderFns } from "./DetallesLeads.vue?vue&type=template&id=8dab2e06"
import script from "./DetallesLeads.vue?vue&type=script&lang=js"
export * from "./DetallesLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports